import { DataTable } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const columns = [
  { key: "studio", label: "Studio" },
  { key: "plan", label: "Plan" },
  { key: "mrr", label: "MRR", align: "right" as const },
  { key: "active", label: "Active", align: "center" as const },
];

const rows: (string | number | boolean | null)[][] = [
  ["Northwind AI", "Pro", 1290, true],
  ["Acme Tutors", "Free", 0, false],
  ["Globex Labs", "Enterprise", 8400, true],
  ["Initech", "Pro", 990, true],
  ["Soylent", "Free", 0, null],
  ["Umbrella", "Enterprise", 12300, true],
  ["Stark", "Pro", 2100, true],
];

export function DataTableDemo() {
  return (
    <Section
      id="data-table"
      title="DataTable"
      description="Sortable, paginated table. Renderer for the K2 `table` block - props are the streamed `{ columns[], rows[][], sort?, page? }` (positional cells)."
    >
      <VariantBlock label="Sortable + paginated">
        <div className="w-full max-w-2xl">
          <DataTable
            columns={columns}
            rows={rows}
            sort={{ by: "mrr", direction: "desc" }}
            page={{ size: 4 }}
            caption="Studio billing snapshot"
          />
        </div>
      </VariantBlock>

      <VariantBlock label="States">
        <div className="w-full max-w-2xl space-y-4">
          <DataTable columns={columns} rows={[]} emptyMessage="No studios yet." />
          <DataTable columns={columns} rows={rows} loading />
          <DataTable columns={columns} rows={rows} error />
        </div>
      </VariantBlock>
    </Section>
  );
}
